import type { PatientIntakeStep, StatusActivityStatus } from '@shared/patient-intake-status';

export const getStepStatus = <TStep extends PatientIntakeStep>(step: TStep): StatusActivityStatus => {
  if (step.stepType === 'BASE_STEP') {
    return step.currentStatus.status;
  }

  return step.currentStatus?.status ?? 'NOT_STARTED';
};
